module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Regular.b5ed9330.otf";